import React from 'react';
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../components/TableIcons';
import {changeWorkQueueSession} from '../../redux/reducers/WorkQueueList';

function Paginate({getWorkQueueListDataFn, workQueueListData}) {
  const handleChange = (name, value) => {
    const {workQueueNextAccount, updateSession} = changeWorkQueueSession();
    const payload = {...workQueueNextAccount?.payload, [name]: value};
    updateSession({...workQueueNextAccount, payload});
    getWorkQueueListDataFn(payload);
  };

  return (
    <div className="global-field-table-footer split-footer">
      <TablePagination
        icons={tableIcons}
        count={workQueueListData?.count || 0}
        page={workQueueListData?.page - 1}
        rowsPerPage={workQueueListData?.limit}
        SelectProps={{
          inputProps: {'aria-label': 'Rows per screen'},
        }}
        labelRowsPerPage={'Rows per screen:'}
        rowsPerPageOptions={[15, 50, 100]}
        onPageChange={(event, number) => {
          handleChange('page', number + 1);
        }}
        onRowsPerPageChange={(event) => {
          handleChange('limit', event.target.value);
        }}
      />
    </div>
  );
}

export default Paginate;
